import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CheckoutShippingUSAddressValidateState from "@tKgpco/Store/Data/CheckoutShipping/CheckoutShippingUSAddressValidateState";
import { Draft } from "immer";

const initialState: any = {};
export const reducer = {
    "Custom/CheckoutShipping/SaveDeliveryInfo": (draft: Draft<any>, action: { DeliveryInfo: any }) => {
        draft.DeliveryInfo = action.DeliveryInfo;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
